import { render, staticRenderFns } from "./PendingTopUp.vue?vue&type=template&id=61966a3c"
import script from "./PendingTopUp.vue?vue&type=script&lang=js"
export * from "./PendingTopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports